import React from 'react';
import useAsyncDataCourier from '../../common/custom-hooks/useAsyncDataCourier';
import MessageCourier from '../../lib/MessageCourier';
import { Provincia } from '../../system/Provincia/Provincia';
import SystemClient from '../../system/SystemClient';
import ComboBoxSearch, { IComboBoxSearch } from '../Common/ComboBoxSearch';
import { IComboBoxOption } from '@fluentui/react';
import ComboBoxInput from '../../lib/FormValidator/Form/ComboBoxInput';
import CustomInputIfc from '../../lib/FormValidator/Form/CustomInputIfc';
import { t } from 'i18next';
import { useTranslation } from 'react-i18next';
import useForceUpdate from '../../common/custom-hooks/useForceUpdate';
interface IProvinciaSelector {
  system: SystemClient;
  courier: MessageCourier;
  comboboxParams: IComboBoxSearch;
}

export const ProvinciaSelector = (props: IProvinciaSelector) => {
  const provincias = useAsyncDataCourier(
    () => props.system.getProvinciasForDropdown(),
    [],
    props.courier
  );
  const provinciaOptions = React.useMemo(() => {
    let ret: IComboBoxOption[] = [];
    if (provincias) {
      provincias.map((entity: Provincia) => {
        return { key: entity.getId()!, text: String(entity.getId()!), data: entity };
      });
    }

    return ret;
  }, [provincias]);
  return <ComboBoxSearch {...props.comboboxParams} options={provinciaOptions}></ComboBoxSearch>;
};

interface IProvinciaSelectorInput {
  system: SystemClient;
  courier: MessageCourier;
  input: CustomInputIfc;
  hideLabel?: boolean;
  onBlurCustomInput: (customInput: CustomInputIfc) => void;
  providedList?: Provincia[];
}

export const ProvinciaSelectorInput = (props: IProvinciaSelectorInput) => {
  const { t, i18n } = useTranslation();
  const [currentProvincia, setCurrentProvincia] = React.useState<Provincia | undefined>(undefined);
  const [provinciaOptions, setProvinciaOptions] = React.useState<IComboBoxOption[]>([]);
  const provincias = useAsyncDataCourier(
    () =>
      props.providedList
        ? Promise.resolve(props.providedList)
        : props.system.getProvinciasForDropdown(),
    [],
    props.courier
  );
  const mapProvinciaOptions = (provincias: Provincia[]) => {
    const opciones = provincias.map((entity: Provincia) => {
      return { key: entity.getId()!, text: getLabelFromProvincia(entity), data: entity };
    });
    setProvinciaOptions(opciones);
  };
  const selectDefaultProvincia = (id: string) => {
    setCurrentProvincia(
      provincias ? provincias.find((entity: Provincia) => entity.getId() === id) : undefined
    );
  };
  const forceUpdate = useForceUpdate();
  const getLabelFromProvincia = (entity: Provincia) => {
    const label = String(entity.getNombre()!);
    return label;
  };

  React.useEffect(() => {
    forceUpdate();
  }, [currentProvincia]);

  React.useEffect(() => {
    selectDefaultProvincia(props.input.getValue());
    mapProvinciaOptions(provincias ? provincias : []);
  }, [provincias, currentProvincia, props.input]);

  const getStartingSelectionProvincia = () => {
    let ret = '';
    if (provincias) {
      const _entity = provincias.find((e: Provincia) => e.getId() === props.input.getValue());
      if (_entity) ret = getLabelFromProvincia(_entity);
    }

    return ret;
  };
  return (
    <>
      {provincias && (
        <ComboBoxInput
          input={props.input}
          label={props.hideLabel ? '' : t('Provincia')}
          onBlur={props.onBlurCustomInput}
          options={provinciaOptions ? provinciaOptions : []}
          selectedKey={currentProvincia?.getId() || getStartingSelectionProvincia()}
        />
      )}
    </>
  );
};
